import React, { useState } from 'react'

import {
  Button,
  FlyoutBody,
  FlyoutHeader,
  FlyoutMenu,
  Icon,
  InlineButton,
} from '../../../index'
import { aggregationsSortingToRender } from '../../../../utils'
import { useTranslation } from '../../../../utils/providers'

import ActiveFilters from '../ActiveFilters'
import MobileFilterList from './MobileFilterList'

function FilterFlyout({
  aggregations = {},
  totalProductCount = 0,
  numberOfActiveFilters = 0,
  submitForms,
  resetAllFilters,
  isVisible = false,
  hide,
  categoryUrls,
  searchData,
}) {
  const { t } = useTranslation()
  const [visibleFilter, setVisibleFilter] = useState(null)

  const backButtonLabel = t('MOBILE_FILTER_BACK')

  const sortedAggregationsToRender = aggregationsSortingToRender(aggregations)

  return (
    <form id="product-list-filter-form" className="mobile-filter">
      <FlyoutMenu isVisible={isVisible} hide={hide}>
        <FlyoutHeader>
          <InlineButton
            className="px-2 py-0 mr-2"
            onClick={hide}
            title={backButtonLabel}
            aria-label={backButtonLabel}
          >
            <Icon symbol="cf-prev" />
          </InlineButton>
          <strong className="flex-grow">{t('FILTER_HEADING')}</strong>
          {numberOfActiveFilters > 0 && (
            <InlineButton className="text-underline" onClick={resetAllFilters}>
              {t('FILTER_RESET_ALL')}
            </InlineButton>
          )}
        </FlyoutHeader>
        <FlyoutBody>
          <div className="mobile-filter__wrap">
            {sortedAggregationsToRender.map((aggregation) => {
              const { key: id, title, min, max } = aggregation

              return (
                <div key={id} className="mobile-filter__section">
                  <button
                    type="button"
                    className="mobile-filter__button reset-btn"
                    onClick={() => setVisibleFilter(id)}
                  >
                    {title}
                    {<ActiveFilters {...aggregation} />}
                    <Icon symbol="cf-next" />
                  </button>

                  <MobileFilterList
                    {...aggregation}
                    id={id}
                    title={title}
                    key={max ? `${id}-${min}-${max}` : id}
                    isVisible={visibleFilter == id}
                    closeFilter={() => setVisibleFilter(null)}
                    submitForms={() => submitForms({ resetPagination: true })}
                    categoryUrls={categoryUrls}
                    searchData={searchData}
                  />
                </div>
              )
            })}
          </div>
          <div className="mobile-filter__footer text-center p-3">
            <Button variant="primary" onClick={hide}>
              {t('MOBILE_FILTER_CLOSE')(totalProductCount)}
            </Button>
          </div>
        </FlyoutBody>
      </FlyoutMenu>
    </form>
  )
}

export default FilterFlyout
